import * as React from 'react'
import { useState } from 'react'
import styled from 'styled-components'
import { ConfigUiHint, JsonSchema } from '../../../types'

type Props = {
  label: string
  value: string
  schema: JsonSchema
  hint?: ConfigUiHint
  disabled?: boolean
  onChange: (val: string) => void
}

const Wrapper = styled.div`
  margin-bottom: 16px;
`

const Label = styled.label`
  display: block;
  color: ${(p) => p.theme.label};
  font-size: 12px;
  margin-bottom: 4px;
  font-family: 'NunitoSansSemiBold';
`

const InputRow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

const Input = styled.input`
  background: ${(p) => p.theme.input.default};
  border: none;
  border-radius: ${(p) => p.theme.radius};
  color: ${(p) => p.theme.white};
  caret-color: ${(p) => p.theme.white};
  padding: 10px 40px 10px 12px;
  font-size: 14px;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  min-height: 44px;

  &::placeholder { color: ${(p) => p.theme.listDesc}; }
  &:focus { box-shadow: 0 0 0 2px ${(p) => p.theme.accent}; outline: none; }
  &:disabled {
    background: ${(p) => p.theme.input.disabled};
    cursor: not-allowed;
  }
`

const EyeButton = styled.button`
  position: absolute;
  right: 4px;
  background: none;
  border: none;
  color: ${(p) => p.theme.gray};
  cursor: pointer;
  padding: 8px;
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  border-radius: ${(p) => p.theme.radius};
  transition: color 0.15s;

  &:hover { color: ${(p) => p.theme.white}; }
  &:focus-visible {
    box-shadow: 0 0 0 2px ${(p) => p.theme.accent};
    color: ${(p) => p.theme.white};
    outline: none;
  }
`

const HelpText = styled.span`
  display: block;
  color: ${(p) => p.theme.listDesc};
  font-size: 12px;
  margin-top: 4px;
`

export function SensitiveField({ label, value, hint, disabled, onChange }: Props) {
  const [revealed, setRevealed] = useState(false)

  return (
    <Wrapper>
      <Label>{label}</Label>
      <InputRow>
        <Input
          type={revealed ? 'text' : 'password'}
          value={value ?? ''}
          placeholder={hint?.placeholder ?? '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022'}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
        />
        <EyeButton
          type="button"
          onClick={() => setRevealed((v) => !v)}
          aria-label={revealed ? 'Hide value' : 'Show value'}
          title={revealed ? 'Hide value' : 'Show value'}
        >
          {revealed ? '\u25C9' : '\u25CE'}
        </EyeButton>
      </InputRow>
      {hint?.help && <HelpText>{hint.help}</HelpText>}
    </Wrapper>
  )
}
